import React from 'react'
import { useSelector } from 'react-redux'
import { selectFirstAddress } from '../../store/address/address.selectors'
import { withEmptyFallbackErrorBoundary } from '../error/EmptyFallbackErrorBoundary'
import ShareUrlButton from '../genericComponents/ShareUrlButton'

// webpack:BrowserOnly
export default withEmptyFallbackErrorBoundary(function AddressShareButton() {
  const { label } = useSelector(selectFirstAddress)

  return <ShareUrlButton title={label} description={label} url={location.href} />
})
